import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PlanList, { PLAN_APPENDIX_DETAIL } from './components/PlanList';
import { fetchCurrencies, fetchPlans } from './PlanAction';
import { branchesSelector } from '../../../Organisation/scenes/Branch/BranchSelectors';
import { plansSelector } from './PlanSelectors';
import { orgIdSelector } from '../../../Organisation/OrganisationSelectors';

const INFO_MSG = (
  <>
    <p>
      The Business Continuity Governance Committee is required to determine which business locations require a plan.
      This is discretionary but clearly if a business location is strategically important to the business it ought to
      have a plan of its own.
    </p>
    <p>
      Click the &apos;Add new&apos; button and give your Plan a name and assign it to a Business Location. Allocate an
      Internal Contact that will become the &apos;Accountable Person&apos; for that plan.
    </p>
    <p>
      You will require a unique Subscription Key to create a new plan. This Subscription Key will have been provided to
      you or it can either be purchased through ContinuityCoach or obtained from a subscribing partner (insurance
      broker/agent, insurance company).
    </p>
  </>
);

const SECTION_TOOLTIP = (
  <>
    {INFO_MSG}
    {PLAN_APPENDIX_DETAIL}
  </>
);

const SECTION_GUIDANCE = (
  <>
    <strong>What to do:</strong> create a continuity plan per location with <strong>Add First Plan</strong> (needs a{' '}
    subscription key). Open an existing row to continue working in that plan.
  </>
);

const Plan = ({ history, plans = [], branches = [], fetchCurrencies, fetchPlans, orgId }) => {
  const planList = plans.map(plan => {
    const branch = branches.find(b => b.branchId === plan.branchId) || {};
    return { ...plan, branch: branch.name, address: branch.address };
  });

  useEffect(() => {
    fetchCurrencies();
  }, [fetchCurrencies]);

  useEffect(() => {
    if (orgId) fetchPlans(orgId);
  }, [orgId, fetchPlans]);

  return (
    <PlanList
      sectionTooltip={SECTION_TOOLTIP}
      sectionGuidance={SECTION_GUIDANCE}
      planList={planList}
      history={history}
      orgId={orgId}
    />
  );
};

const mapStateToProps = state => ({
  orgId: orgIdSelector(state),
  plans: plansSelector(state),
  branches: branchesSelector(state)
});

const mapDispatchToProps = { fetchCurrencies, fetchPlans };

export default connect(mapStateToProps, mapDispatchToProps)(Plan);
